import React, { type FunctionComponent } from 'react'

import { TableProductCell } from 'legacy/dash-components/table-product-cell/TableProductCell'
import Modal from 'legacy/components/Modal'

export type ReplacementModalProps = {
  productId?: string
  productName?: string
  imageUrl?: string
  onClose?: () => void
}

export const ReplacementModal: FunctionComponent<ReplacementModalProps> = ({
  productId,
  productName,
  imageUrl,
  onClose,
}) => {
  return (
    <Modal width={800} height={162} onClose={onClose}>
      {(Head, BodyContainer) => [
        <Head>Replaced by</Head>,
        <BodyContainer style={{ padding: '5px 10px' }}>
          <TableProductCell productId={productId} productName={productName} imageUrl={imageUrl} />
        </BodyContainer>,
        null,
      ]}
    </Modal>
  )
}
